// https://github.com/winstonjs/winston#logging-levels

const LogLevel = {
  ERROR: 'error', // 0 - Highest severity
  WARN: 'warn', // 1
  INFO: 'info', // 2
  HTTP: 'http', // 3
  VERBOSE: 'verbose', // 4
  DEBUG: 'debug', // 5
  SILLY: 'silly', // 6 - Lowest severity
} as const;

export { LogLevel };
